import { lazy } from 'react';

// project imports
import GuestLayout from 'layout/GuestLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import PortalThemeProvider from 'themes/PortalThemeProvider';

// Dashboard
const EvidenceUpload = Loadable(lazy(() => import('views/guest-portal/')));
const Instructions = Loadable(lazy(() => import('views/guest-portal/instructions')));
const GuestInformation = Loadable(lazy(() => import('views/guest-portal/information')));

const Error404 = Loadable(lazy(() => import('views/error/Error404')));

const GuestRoutes = {
    path: '/',
    errorElement: (
        <PortalThemeProvider>
            <Error404 />
        </PortalThemeProvider>
    ),
    element: (
        <PortalThemeProvider>
            <AuthGuard allowedPrincipalTypes={['guest']}>
                <GuestLayout />
            </AuthGuard>
        </PortalThemeProvider>
    ),
    children: [
        {
            path: '/guest/:requestCode',
            children: [
                {
                    path: '',
                    element: <Instructions />
                },
                {
                    path: 'information',
                    element: <GuestInformation />
                },
                {
                    path: 'start',
                    element: <EvidenceUpload />
                }
            ]
        }
    ]
};

export default GuestRoutes;
